import script from "./OTPInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./OTPInput.vue?vue&type=script&setup=true&lang=ts"

import "./OTPInput.vue?vue&type=style&index=0&id=d340804c&lang=css"
import "./OTPInput.vue?vue&type=style&index=1&id=d340804c&lang=css"

const __exports__ = script;

export default __exports__